(ns frontend.ui.page.lp-report-editor.step-6-publishing-queue.view
  (:require
   [common.localization :as loc]
   [frontend.ui.page.lp-report-editor.common.event :as common-event]
   [frontend.ui.page.lp-report-editor.common.modal.pdf-preview-modal :as pdf-preview-modal]
   [frontend.ui.page.lp-report-editor.common.style :as common-style]
   [frontend.ui.page.lp-report-editor.common.view :refer
    [continue-button footer next-button preview-pdf-button] :as common-view]
   [frontend.ui.page.lp-report-editor.event :as editor-event]
   [frontend.ui.page.lp-report-editor.step-6-publishing-queue.event :as event]
   [frontend.ui.page.lp-report-editor.step-6-publishing-queue.sub :as sub]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [frontend.view.modals.confirmation.view :as confirmation-modal]
   [frontend.view.modals.events :as modals]
   [herb.core :refer [<class]]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]))

(defn step-footer
  [selected-report feeder?]
  (let [report @(rf/subscribe [::editor-sub/lp-report])
        full-access? @(rf/subscribe [::editor-sub/full-access?])
        wip? @(rf/subscribe [::editor-sub/reports-not-approved?])]
    [footer
     {:left-content
      [:<>
       [continue-button]
       [:div
        [pdf-preview-modal/view
         {:on-close #(rf/dispatch [::common-event/close-pdf-preview])
          :report   selected-report
          :feeder?  feeder?}]
        [preview-pdf-button
         {:on-click #(rf/dispatch [::common-event/open-pdf-preview selected-report feeder?])}]]
       (when-let [burned-pdfs (seq (:lp-report/burned-pdfs selected-report))]
         [:div
          [button/secondary-hollow
           {:on-click #(rf/dispatch [::editor-event/open-burned-pdf burned-pdfs])}
           (loc/tr :open-burned-pdf)]])]
      :right-content
      [:<>
       (when full-access?
         [:div
          {:class (<class common-style/spacing-left)}
          (if (not= :lp-report.step/publishing-queue (:lp-report/step report))
            [next-button [::editor-event/activate-step :lp-report.step/published]]
            [button/primary-solid
             {:disabled? wip?
              :on-click  (fn []
                           (modals/open-modal!
                            confirmation-modal/modal-key
                            {:body           [:div.text-center
                                              [:p.mb-0 (loc/tr :you-are-publishing)]
                                              [:p.pt-3 (loc/tr :do-you-want-to-proceed)]]
                             :confirm-text   (loc/tr :yes-publish)
                             :confirm-class  "zap-btn__solid__green"
                             :confirm-color  ""
                             :confirm-icon   ""
                             :cancel-text    (loc/tr :no-cancel)
                             :title          (loc/tr :force-publish)
                             :skip-checkbox? true
                             :on-confirm     #(rf/dispatch [::event/force-publish (:db/id report)])}))}
             (loc/tr :force-publish)])])]}]))

(defn publishing-queue
  []
  [common-view/report-viewer sub/report-tab-path step-footer])


(defn body
  []
  [publishing-queue])
